/* istanbul ignore file */
// @ts-nocheck
import ReactGA from 'react-ga';

import config from '../config/config';

const configApi = { gaId: config.googleAnalyticsId };
const initializeGoogleAnalytics = () => {
  ReactGA.initialize(configApi.gaId);
};

export default initializeGoogleAnalytics;
